import { cn } from "@/lib/utils"

export function ChatMessages({ messages, isTyping, messagesEndRef }) {
    return (
        <div className="flex min-h-0 flex-1 flex-col gap-2.5 overflow-y-auto bg-muted/30 px-4 py-4">
            {messages.map((msg) => (
                <div
                    key={msg.id}
                    className={cn(
                        "flex w-full flex-col gap-0.5",
                        msg.sender === "user" ? "items-end" : "items-start"
                    )}
                >
                    {msg.timestamp && (
                        <span className="px-1 text-[10px] text-muted-foreground">
                            {msg.timestamp}
                        </span>
                    )}
                    <div
                        className={cn(
                            "max-w-[78%] rounded-2xl px-3.5 py-2 text-sm shadow-sm",
                            msg.sender === "user"
                                ? "rounded-br-sm bg-primary text-white"
                                : "rounded-bl-sm border border-border bg-card text-card-foreground"
                        )}
                    >
                        <p className="whitespace-pre-wrap break-words leading-relaxed">{msg.text}</p>
                    </div>
                </div>
            ))}

            {isTyping && (
                <div className="flex items-center gap-1.5 self-start rounded-2xl rounded-bl-sm border border-border bg-card px-4 py-3 shadow-sm">
                    <span className="h-2 w-2 animate-bounce rounded-full bg-muted-foreground/60 [animation-delay:-0.3s]" />
                    <span className="h-2 w-2 animate-bounce rounded-full bg-muted-foreground/60 [animation-delay:-0.15s]" />
                    <span className="h-2 w-2 animate-bounce rounded-full bg-muted-foreground/60" />
                </div>
            )}
            <div ref={messagesEndRef} />
        </div>
    )
}